import ConditionalRender from "app/common/components/ConditionalRender";
import CustomSelect from "app/common/components/CustomSelect";
import { allCountries, currencyFlagObj } from "app/common/data/countries";
import { getCurrencySign } from "app/common/util/Helpers";

const CustomCurrencySelect = ({className, roundedFlag = false, showSign = false, side, exclude = [], ...props}) => {

    let data = props.data || [...new Set(allCountries?.map(item => item.currency))];
    if (exclude?.length > 0){
        const excludeSet = new Set(exclude);
        data = data.filter(item => !excludeSet.has(item));
    }

    const formatField = (item, selected) => <>  
                                    {
                                        selected && side && <span className="inline-block pr-2 mr-2 text-grey-2 font-medium border-r dark:border-dark">
                                                    {side}:
                                                </span>
                                    }
                                    {
                                        item ? <span className="inline-block">
                                                <img
                                                    src={`/assets/media/svg/flag/${currencyFlagObj[item]}.svg`}
                                                    className={`mr-3 inline-block w-5 ${roundedFlag && "rounded-full"}`}
                                                    alt={currencyFlagObj[item]}
                                                />{item} 
                                                <ConditionalRender
                                                    render={showSign}
                                                >
                                                    <span
                                                        className="px-1"
                                                    >
                                                        ({getCurrencySign(item)})
                                                    </span>
                                                </ConditionalRender>

                                    </span>
                                    :
                                    <span className="text-grey-3 inline-block">{props.placeholder || "Select Currency"}</span> 
                                    }
                                </>

    return  <CustomSelect
                placeholder="--"
                formatOpt={item => formatField(item)}
                formatSelected={item => formatField(item, true)}
                className={className}
                {...props}
                data={data}
                searchable={props.searchable ?? true}
            /> 
}

export default CustomCurrencySelect;